import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import championshipService from '../../services/championshipService';
import teamService from '../../services/teamService';
import './TeamForm.css';

function TeamForm() {
  const navigate = useNavigate();
  const [formData, setFormData] = useState({
    name: '',
    city: '',
    foundedYear: '',
    championships: [],
    badge: null,
    existingBadge: null
  });

  const [championships, setChampionships] = useState([]);
  const [error, setError] = useState('');
  const [showChampionships, setShowChampionships] = useState(false);

  useEffect(() => {
    championshipService.getAll()
      .then(response => {
        const data = Array.isArray(response.data) ? response.data : response;
        setChampionships(data);
      })
      .catch(() => setError('Erro ao carregar campeonatos'));
  }, []);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleChampionshipChange = (e) => {
    const selected = Array.from(e.target.selectedOptions).map(o => o.value);
    setFormData((prev) => ({ ...prev, championships: selected }));
  };

  const handleFileChange = (e) => {
    setFormData((prev) => ({ 
      ...prev, 
      badge: e.target.files[0],
      existingBadge: null
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    const data = new FormData();
    data.append('name', formData.name);
    data.append('city', formData.city);
    data.append('foundedYear', formData.foundedYear);
    data.append('championships', JSON.stringify(formData.championships));

    if (formData.badge) {
      data.append('badge', formData.badge);
    }

    // Log dos dados que vão ser enviados
    console.log('Enviando time com os dados:');
    console.log('name:', formData.name);
    console.log('city:', formData.city);
    console.log('foundedYear:', formData.foundedYear);
    console.log('championships (array):', formData.championships);
    if (formData.badge) {
      console.log('badge file:', formData.badge.name, formData.badge.type, formData.badge.size, 'bytes');
    } else {
      console.log('Sem arquivo de logo');
    }

    try {
      await teamService.createTeam(data);
      navigate('/teams');
    } catch (err) {
      setError(err.response?.data?.error || 'Erro ao criar time');
    }
  };

  return (
    <div className="max-w-2xl mx-auto mt-10 p-6 bg-white rounded-2xl shadow-md">
      <h2 className="text-2xl font-bold mb-6">Criar Novo Time</h2>
      {error && <div className="text-red-500 mb-4">{error}</div>}
      <form onSubmit={handleSubmit} className="space-y-4">
        <input
          type="text"
          name="name"
          placeholder="Nome do time"
          required
          onChange={handleChange}
          className="w-full border p-2 rounded"
        />
        <input
          type="text"
          name="city"
          placeholder="Cidade"
          required
          onChange={handleChange}
          className="w-full border p-2 rounded"
        />
        <input
          type="number"
          name="foundedYear"
          placeholder="Ano de fundação"
          onChange={handleChange}
          className="w-full border p-2 rounded"
        />
        <div>
          <label className="block mb-2">Logo do Time:</label>
          <input
            type="file"
            name="badge"
            accept="image/*"
            onChange={handleFileChange}
            required
            className="w-full"
          />
        </div>

        <button
          type="button"
          onClick={() => setShowChampionships(!showChampionships)}
          className="bg-gray-600 text-white px-4 py-2 rounded hover:bg-gray-700"
        >
          {showChampionships ? 'Ocultar Campeonatos' : 'Selecionar Campeonatos'}
        </button>

        {showChampionships && (
          <select
            multiple
            value={formData.championships}
            onChange={handleChampionshipChange}
            className="w-full border p-2 rounded"
          >
            {championships.map(c => (
              <option key={c._id} value={c._id}>{c.name}</option>
            ))}
          </select>
        )}

        <button
          type="submit"
          className="bg-blue-600 text-white px-4 py-2 rounded hover:bg-blue-700"
        >
          Salvar Time
        </button>
      </form>
    </div>
  );
}

export default TeamForm;
